import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { searchApi } from '@/api/services/search.api';
import { useDebouncedValue } from '@/hooks/use-debounced-value';

import { COMMAND_CENTER_QUERY_KEYS, SEARCH_DEBOUNCE_MS, SEARCH_MIN_CHARS } from '../constants';

/**
 * Debounced server search. TanStack passes an AbortSignal per fetch, so a new
 * keystroke cancels the in-flight axios request instead of racing it.
 */
export function useCommandSearch(rawQuery: string) {
    const query = useDebouncedValue(rawQuery.trim(), SEARCH_DEBOUNCE_MS);
    const enabled = query.length >= SEARCH_MIN_CHARS;

    return useQuery({
        queryKey: COMMAND_CENTER_QUERY_KEYS.search(query),
        queryFn: ({ signal }) => searchApi.query(query, signal),
        enabled,
        staleTime: 30_000,
        placeholderData: keepPreviousData,
        retry: 0,
    });
}
